// Vue
import {Vue, Component, Prop} from 'vue-property-decorator'

// Template
import template from './template.vue'

// Components
import {Container} from '../../container/Container'
import {Icon} from '../../icon/Icon'
import {Link} from '../../link/Link'

@Component({
    components: {
        Container,
        Icon,
        Link,
    },
    mixins: [
        template,
    ]
})
export class NavigationBarItem extends Vue {

    @Prop()
    public to!: object

    @Prop()
    public href!: string

    @Prop({default: false})
    public forceA!: boolean

    @Prop({default: 'secondary'})
    public theme!: string

    @Prop()
    public icon?: string

    @Prop()
    public iconFile?: string

    @Prop({default: false})
    public disabled!: boolean

    @Prop({default: false})
    public active!: boolean

    public created () {

    }

    public destroyed() {

    }
}